import SearchBar from '../../components/search-bar/SearchBar';
import DirectoryCardArea from '../../components/directory-card-area/DirectoryCardArea';
import DirectoryList from '../../components/directory-list/DirectoryList';
import HeaderControls from '../../components/header-controls/HeaderControls';
import SearchMobile from '../../components/search-mobile/SearchMobile';

const HomePage = () => {
  return (
    <>
      <div className="header-container-home">
        <div className="hero">
          <h1 className="header-message">Provider Network Directory</h1>
          <HeaderControls />
          <div className="showMobile">
            <SearchMobile />
          </div>
        </div>
      </div>
      <div className="body-container-home">
        <div style={{ marginTop: '-90px' }} className="showDesktop">
          <DirectoryCardArea />
          <SearchBar />
        </div>
      </div>
      <div className="directory-list-container">
        <DirectoryList />
      </div>
    </>
  );
};

export default HomePage;
